import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, checked } = useAuth();
  if (!checked) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="text-slate-400 text-sm uppercase tracking-widest">Loading…</div>
      </div>
    );
  }
  if (!user || !["admin", "recruiting_hr"].includes(user.role)) return <Navigate to={`/admin/login?next=${encodeURIComponent(window.location.pathname)}&expired=1`} replace />;
  return children;
}
